var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-editor',{ref:"editor",attrs:{"editor-toolbar":_vm.customToolbar,"editor-options":_vm.editorOptions},on:{"text-change":_vm.onTextChange},model:{value:(_vm.editorContent),callback:function ($$v) {_vm.editorContent=$$v},expression:"editorContent"}})
}
var staticRenderFns = []

export { render, staticRenderFns }